import { render, staticRenderFns } from "./ClientProperties.vue?vue&type=template&id=03c57d18"
import script from "./ClientProperties.vue?vue&type=script&lang=ts"
export * from "./ClientProperties.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports